import base from '../dr-base'
import drGridLayoutRow from './dr-grid-layout-row.vue'

const schema = {
  $Type: 'dr-grid-layout-row',
  name: 'Grid row',
  group: 'Container widgets',
  allowInToolbox: false,
  properties: {
    ...base.properties,
    Columns: {
      type: 'array',
      items: {
        type: 'object'
      }
    }
  }
}

export default {
  schema,
  component: drGridLayoutRow
}
